import { render, staticRenderFns } from "./inventories.vue?vue&type=template&id=db5e4dbc&"
import script from "./inventories.vue?vue&type=script&lang=js&"
export * from "./inventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports